/**
 * Per-person copilot preferences, browser-local for now (sg_copilot_prefs).
 * Move to the member record once we know which ones people actually change.
 */
const KEY = "sg_copilot_prefs";

export const VOICES = [
  { id: "asteria", name: "Asteria", note: "Confident, knowledgeable", gender: "f" },
  { id: "thalia", name: "Thalia", note: "Clear, energetic", gender: "f" },
  { id: "luna", name: "Luna", note: "Friendly, natural", gender: "f" },
  { id: "hera", name: "Hera", note: "Warm, professional", gender: "f" },
  { id: "athena", name: "Athena", note: "Calm, smooth", gender: "f" },
  { id: "orion", name: "Orion", note: "Approachable, confident", gender: "m" },
  { id: "arcas", name: "Arcas", note: "Natural, smooth", gender: "m" }
];

export const STT_LANGS = [
  { id: "en-IN", name: "India" },
  { id: "en-US", name: "US" },
  { id: "en-GB", name: "UK" }
];

export const DEFAULT_PREFS = {
  voice: "asteria",
  speed: "normal", // normal | fast
  readAloud: "talk", // talk | never
  bargeIn: true,
  sttLang: "en-IN"
};

let cache = null;
const listeners = new Set();

export const getPrefs = () => {
  if (cache) return cache;
  try {
    cache = { ...DEFAULT_PREFS, ...(JSON.parse(localStorage.getItem(KEY) || "{}") || {}) };
  } catch (e) {
    cache = { ...DEFAULT_PREFS };
  }
  return cache;
};

export const setPrefs = patch => {
  cache = { ...getPrefs(), ...patch };
  try {
    localStorage.setItem(KEY, JSON.stringify(cache));
  } catch (e) {
    /* private mode: prefs live for the page only */
  }
  listeners.forEach(fn => fn(cache));
  return cache;
};

export const resetPrefs = () => {
  cache = { ...DEFAULT_PREFS };
  try { localStorage.removeItem(KEY); } catch (e) { /* no storage */ }
  listeners.forEach(fn => fn(cache));
  return cache;
};

export const onPrefsChange = fn => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};
